import { Link } from "@tanstack/react-router";
import { openCookieSettings } from "@/lib/consent";
import { SITE_TAGLINE } from "@/lib/seo";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-background">
      <div className="mx-auto flex max-w-[1600px] flex-col gap-3 px-4 py-6 text-[12px] leading-relaxed text-text-dim md:flex-row md:items-start md:justify-between">
        <div className="space-y-1">
          {/* The site's one tagline, held in src/lib/seo.ts so the footer, the
              signed-out hero, the share card and the meta description cannot
              say four different things again. */}
          <p className="text-[13px] font-semibold text-text-muted">{SITE_TAGLINE}.</p>
          <p>This product uses the TMDB API but is not endorsed or certified by TMDB.</p>
          <p>Streaming availability data provided by JustWatch.</p>
          <p>Ratings via OMDb (IMDb, Rotten Tomatoes, Metacritic).</p>
        </div>
        <div className="flex flex-col gap-2 md:items-end">
          <nav className="flex flex-wrap items-center gap-x-4 gap-y-1 text-text-muted">
            <Link to="/about" className="hover:text-text-bright">
              About
            </Link>
            <Link to="/contact" className="hover:text-text-bright">
              Contact
            </Link>
            <Link to="/privacy" className="hover:text-text-bright">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-text-bright">
              Terms
            </Link>
            <button type="button" onClick={openCookieSettings} className="hover:text-text-bright">
              Cookie settings
            </button>
          </nav>
          {/* The year is read from the clock at render. Around New Year the
              cached page and a visitor's clock can disagree for a few hours;
              a text difference here is not worth rebuilding the page over. */}
          <p suppressHydrationWarning>© {year} Balasaur.</p>
        </div>
      </div>
    </footer>
  );
}
